import { SWAGGER_URL } from "../apiBaseUrl";

export const API_ENDPOINT = {
  USER_AUTHENTICATION: {
    LOGIN : `${SWAGGER_URL}/auth/authenticate`,
  },
  GET_DASHBOARD: {
    METRICS: `${SWAGGER_URL}/dashboard/metrics`,
    RECENT_INTERVIEWS: `${SWAGGER_URL}/dashboard/recent-activity`
  },

  GET_INTERVIEW_CONFIG: {
    LOOKUPS: `${SWAGGER_URL}/interview-config-builder/lookup-options`,
    LIST: `${SWAGGER_URL}/interview-config-builder`,
    UPDATE: `${SWAGGER_URL}/interview-config-builder`,
    INTERVIEW_TYPE_BY_CATEGORY: `${SWAGGER_URL}/interview-config-builder/interview-type-by-category`,
  },
  CREATE_INTERVIEW: {
    MIX_MATCH: `${SWAGGER_URL}/interview-config-builder`,
  },
  STUDENT_MANAGEMENT:{
    CREATE: `${SWAGGER_URL}/api/students`,
    GET_ALL: `${SWAGGER_URL}/api/students`,
    ACTIVE_INTERVIEW: `${SWAGGER_URL}/studentInterview/active-interview`,
    STUDENT_STATS: `${SWAGGER_URL}/api/students/stats`,
    EDIT_STUDENT: `${SWAGGER_URL}/api/students/`,
    ADD_BULK_STUDENT: `${SWAGGER_URL}/generic-requests`,
  },
  SCHEDULE: {
    GET_SCHEDULE_INTERVIEWS:`${SWAGGER_URL}/interview-candidate-mappings/interviews-scheduled`,
    CREATE_SCHEDULE_INTERVIEWS: `${SWAGGER_URL}/interview-candidate-mappings`,
    UPDATE_SCHEDULE_INTERVIEWS: `${SWAGGER_URL}/interview-candidate-mappings`,
    METRICS_SCEDULE_INTERVIEWS: `${SWAGGER_URL}/dashboard/scheduling-metrics`,
  },
  QUESTION_TAB: {
    GET_ALL_QUESTIONS: `${SWAGGER_URL}/questions/fetch-All`,
    UPDATE_QUESTION: `${SWAGGER_URL}/questions`
  },
  GET_STUDENT_DASHBOARD: {
    GET_ACTIVE_INTERVIEWS: `${SWAGGER_URL}/studentInterview/active-interview`,
    GET_ALL_ACTIVE_INTERVIEWS: `${SWAGGER_URL}/studentInterview/all-active-interview`,
    GET_COMPLETED_INTERVIEWS: `${SWAGGER_URL}/studentInterview/completed-interview`,
    GET_STUDENT_METRICS: `${SWAGGER_URL}/studentInterview/student-metrics`,
    STUDENT_MARKS: `${SWAGGER_URL}/studentInterview/student-marks`,
    CATEGORY_PERFORMANCE: `${SWAGGER_URL}/studentInterview/category-performance`,
  },
  REPORT_EVALUATION: {
    GET_ALL_REPORTS: `${SWAGGER_URL}/report-evaluations`,
  },
  STUDENT_SURVEY: {
    FETCH_ALL: `${SWAGGER_URL}/student-survey/fetch-all`,
    CREATE: `${SWAGGER_URL}/student-survey`,
  },
  ADMIN_SURVEY: {
    GET_BY_INTERVIEW: `${SWAGGER_URL}/admin-survey`,
    CREATE: `${SWAGGER_URL}/admin-survey`,
  },
  SETTINGS: {
    GET_ALL_SETTINGS: `${SWAGGER_URL}/system-setting/active`,
    UPDATE_SETTINGS: `${SWAGGER_URL}/system-setting`,
  }
};
